<template>
  <nav class="the-nav-bar">
    <ul v-if="appMenu" class="app-menu">
      <li>
        <router-link to="/" class="nav-home">
          <i class="fas fa-home"></i>
          ASD
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard">
          {{ $t("common.dashboard") }}
        </router-link>
      </li>
      <li>
        <router-link to="/projects">
          {{ $t("navbar.projects") }}
        </router-link>
      </li>
      <li>
        <router-link to="/tasks">
          {{ $t("navbar.tasks") }}
        </router-link>
      </li>
      <!-- <li>
        <router-link to="/calendar">
          {{ $t("navbar.calendar") }}
        </router-link>
      </li> -->
      <li v-if="$store.getters.currentUserHasAction('ADD_RESOURCE') || $store.getters.currentUserHasAction('EDIT_RESOURCE')">
        <router-link to="/resources">
          {{ $t("navbar.resources") }}
        </router-link>
      </li>
      <li v-if="$store.getters.groupedActions.includes('EDIT_PROPERTIES')">
        <router-link to="/property-type">
          {{ $t("navbar.property-types") }}
        </router-link>
      </li>
      <li v-if="$store.getters.groupedActions.includes('EDIT_SETTINGS')">
        <router-link to="/settings">
          {{ $t("navbar.settings") }}
        </router-link>
      </li>
      <li v-if="$store.getters.groupedActions.includes('READ_OTHER_USERS') || $store.getters.groupedActions.includes('EDIT_OTHER_USERS')">
        <router-link to="/users">
          {{ $t("navbar.users") }}
        </router-link>
      </li>
      <li class="app-menu--separator">
      </li>
      <!-- <li>
        <LangChanger></LangChanger>
      </li> -->
      <li style="z-index: 9999">
        <UserMenu></UserMenu>
      </li>
      <li>
        <NotificationsMenu></NotificationsMenu>
      </li>
      <li>
        <OnlineUpdates></OnlineUpdates>
      </li>
    </ul>
  </nav>
</template>

<script>
import UserMenu from './user-menu'
import OnlineUpdates from './online-updates'
import NotificationsMenu from './notifications.vue'
import { get } from 'lodash'

export default {
    name: 'TheNavBar',
    components: {
        UserMenu,
        OnlineUpdates,
        NotificationsMenu,
    },
    computed: {
        appMenu() {
            return this.$store.getters.isLoggedIn
        },
        authorizations() {
            return get(this.$store.getters.currentUser, 'settings.authorization', {})
        },
    },
}
</script>

<style scoped lang="scss">
nav.the-nav-bar {
  background-color: var(--color-primary);
  color: var(--color-primary-inverse);
}
.app-menu {
  display: flex;
  flex-direction: row;
  height: 30px;
  .nav-home {
    font-weight: bold;
  }
  &--separator {
    flex-grow: 1;
  }
}
.app-menu > li {
  display: block;  
  &>a {
    display: block;
    width: 100%;
    padding: 0 10px;
    color: white;
    text-transform: uppercase;
    font-size: 0.9rem;
    line-height: 30px;
    &:hover {
      background-color: rgba(255,255,255,0.8);
      color: var(--color-primary);
      text-decoration: none;
    }
    &.router-link-active {
      background-color: rgba(255,255,255,0.2);
    }
  }
}
nav ul {
  list-style: none;
}
</style>
